"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredColumnTree = exports["default"] = exports.ColumnTreeContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tabs = _interopRequireDefault(require("./Tabs"));
var _cccisdFormik = require("cccisd-formik");
var _FilterForm = _interopRequireWildcard(require("./FilterForm"));
var _AssignmentForm = _interopRequireDefault(require("./AssignmentForm"));
var _CheckboxInput = _interopRequireDefault(require("./CheckboxInput"));
var _TagInput = _interopRequireDefault(require("./TagInput"));
var _MetricsPicker = _interopRequireDefault(require("./MetricsPicker"));
var _Panel = _interopRequireDefault(require("../Panel"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _union2 = _interopRequireDefault(require("lodash/union"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _flatten2 = _interopRequireDefault(require("lodash/flatten"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _pushpin = _interopRequireDefault(require("cccisd-icons/pushpin"));
var _metricTypes = _interopRequireDefault(require("../../Code/metricTypes.js"));
var _getColumnTree = _interopRequireDefault(require("./getColumnTree.js"));
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
var _reactRedux = require("react-redux");
var _admin = require("../../../selectors/admin.js");
var _mergeColumnTree = _interopRequireDefault(require("./mergeColumnTree.js"));
var _removeIdentifiableFields = _interopRequireDefault(require("./removeIdentifiableFields.js"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _classnames = _interopRequireDefault(require("classnames"));
var _getRoleHandlesFromDeploymentList = _interopRequireDefault(require("../getRoleHandlesFromDeploymentList.js"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _excluded = ["handleSubmit", "values", "errors", "submitCount", "setFieldValue"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Fortress = window.cccisd.fortress;
var showQueryToOptions = [{
  value: 'all',
  label: 'Users with and without identifiable permission for this Quest Project'
}, {
  value: 'withIdentifiable',
  label: 'Only users with identifiable permission for this Quest Project'
}];
var csvHeaderOptions = [{
  value: 'label',
  label: 'Variable'
}, {
  value: 'question',
  label: 'Question'
}, {
  value: 'originalLabel',
  label: 'Label'
}];
var getFilteredColumnTree = exports.getFilteredColumnTree = function getFilteredColumnTree(search, columnTree1) {
  var result = (0, _cloneDeep2["default"])(columnTree1);
  search = search.toLowerCase();
  function filterTree(node) {
    if (!node.label) {
      return false;
    }
    if (node.children) {
      node.children = node.children.filter(filterTree);
      return node.children.length > 0;
    }
    return node.label.toLowerCase().includes(search);
  }
  return result.filter(filterTree);
};
var ColumnTreeContext = exports.ColumnTreeContext = /*#__PURE__*/_react["default"].createContext([]);
var validate = function validate(values) {
  var errors = {};
  var result = (0, _FilterForm.validate)(values.filter);
  if (result) {
    for (var _i = 0, _Object$entries = Object.entries(result); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      errors["filter.".concat(key)] = value;
    }
  }
  return errors;
};
var FormItself = function FormItself(props) {
  var values = props.values,
    errors = props.errors,
    submitCount = props.submitCount,
    setFieldValue = props.setFieldValue,
    assignmentMetrics = props.assignmentMetrics,
    loadAssignmentMetrics = props.loadAssignmentMetrics;
  var usedColumns = new Set();
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    search = _useState4[0],
    setSearch = _useState4[1];
  var projectFields = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProjectFields)(state.assignment.admin);
  });
  var adminState = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin;
  });
  var availableTags = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getAvailableTags)(state.assignment.admin);
  });
  var project = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProject)(state.assignment.admin);
  });
  var restrictionsLevel = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getRestrictionsLevel)(state.assignment.admin);
  });
  var columnTree = (0, _react.useMemo)(function () {
    var adjustedState = (0, _immutabilityHelper["default"])(adminState, {
      currentQuerySettings: {
        assignmentId: {
          $set: Number(values.assignmentId)
        }
      }
    });
    var deploymentList = (0, _admin.getCurrentQueryAssignmentActiveDeployments)(adjustedState);
    var roleHandles = (0, _getRoleHandlesFromDeploymentList["default"])(deploymentList.filter(function (item) {
      return values.deploymentIds === 'all' || values.deploymentIds.includes(item.deploymentId);
    }));
    var currentColumnTree = roleHandles.length === 0 ? (0, _getColumnTree["default"])({
      level: 'roles',
      projectFields: projectFields
    }) : (0, _mergeColumnTree["default"])(roleHandles.map(function (name) {
      return (0, _getColumnTree["default"])({
        level: 'roles',
        rows: name,
        projectFields: projectFields
      });
    }));

    // remove identifiable fields if the user doesn't have permissions
    if (!Fortress.hasAccess('quest.view_identifiable_data', project.groupId) && roleHandles.length > 0) {
      var identifiableFields = window.cccisd.appDefs.pawn.roles.reduce(function (list, role) {
        if (roleHandles.includes(role.handle)) {
          (role.identifiableFields || []).forEach(function (field) {
            list.add(field);
          });
        }
        return list;
      }, new Set());
      for (var _i2 = 0, _Object$values = Object.values(projectFields); _i2 < _Object$values.length; _i2++) {
        var field = _Object$values[_i2];
        if (field.isIdentifiable) {
          identifiableFields.add(field.path);
        }
      }
      return (0, _removeIdentifiableFields["default"])(currentColumnTree, identifiableFields);
    }
    return currentColumnTree;
  }, [adminState, values.assignmentId, values.deploymentIds, projectFields]);
  var filteredTree = (0, _react.useMemo)(function () {
    return getFilteredColumnTree(search, columnTree);
  }, [search, columnTree]);
  var variables = (0, _react.useMemo)(function () {
    if (!assignmentMetrics[values.assignmentId]) {
      return [];
    }
    var hasIdenifiablePermission = Fortress.hasAccess('quest.view_identifiable_data', project.groupId);
    return assignmentMetrics[values.assignmentId].filter(function (item) {
      return hasIdenifiablePermission || !item.isIdentifying;
    }).sort(function (a, b) {
      return a.reportHeader.localeCompare(b.reportHeader);
    });
  }, [assignmentMetrics, values.assignmentId]);
  (0, _react.useEffect)(function () {
    loadAssignmentMetrics(values.assignmentId);
  }, [values.assignmentId]);
  var variablesOptions = (0, _react.useMemo)(function () {
    var handleSet = new Set(values.surveyHandles === 'all' ? [] : values.surveyHandles);
    var metricsByType = variables.filter(function (variable) {
      return values.surveyHandles === 'all' || variable.surveyHandles.some(function (handle) {
        return handleSet.has(handle);
      });
    }).reduce(function (obj, item) {
      var _item$content;
      obj[item.type] = obj[item.type] || [];
      obj[item.type].push({
        id: item.reportHeader,
        label: item.label,
        question: (_item$content = item.content) === null || _item$content === void 0 ? void 0 : _item$content.title
      });
      return obj;
    }, {});
    return _metricTypes["default"].filter(function (type) {
      return type.value !== 'correct' || restrictionsLevel === 'unlimited';
    }).map(function (type) {
      return _objectSpread(_objectSpread({}, type), {}, {
        list: metricsByType[type.value] || []
      });
    });
  }, [variables, values.surveyHandles, restrictionsLevel]);

  // set metrics value
  (0, _react.useEffect)(function () {
    var newList = _union2["default"].apply(void 0, [values.metrics.list].concat(_toConsumableArray(variablesOptions.filter(function (option) {
      return values.metrics.types.includes(option.value);
    }).map(function (option) {
      return option.list.map(function (item) {
        return item.id;
      });
    }))));
    setFieldValue('metrics', _objectSpread(_objectSpread({}, values.metrics), {}, {
      list: newList
    }));
    setFieldValue('variablesOptions', variablesOptions);
  }, [variablesOptions]);
  var toggleExpanded = function toggleExpanded(value) {
    return setExpanded((0, _xor2["default"])(expanded, [value]));
  };
  var getTabs = function getTabs() {
    var _traverse = function traverse(node, field, form) {
      if (node.children) {
        var isExpanded = expanded.includes(node.id) || !!search;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].header,
          onClick: function onClick() {
            return toggleExpanded(node.id);
          }
        }, isExpanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
          spaceRight: true
        }) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
          spaceRight: true
        }), node.label), isExpanded && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].level
        }, node.children.map(function (child) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: child.id
          }, _traverse(child, field, form));
        })));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check d-flex align-items-center"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, usedColumns.has(node.id) && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].used
      }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)), /*#__PURE__*/_react["default"].createElement("input", {
        className: "form-check-input",
        type: "checkbox",
        value: node.id,
        checked: node.id in field.value,
        onChange: function onChange(e) {
          form.setFieldValue(field.name, e.target.checked ? _objectSpread(_objectSpread({}, field.value), {}, _defineProperty({}, node.id, node)) : (0, _omit2["default"])(field.value, node.id));
        },
        disabled: usedColumns.has(node.id),
        style: usedColumns.has(node.id) ? {
          visibility: 'hidden'
        } : {}
      }), ' ', node.label), node.id in field.value && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        title: "Selected fields will be shown as columns in the table",
        className: (0, _classnames["default"])('btn btn-xs', _style["default"].button, field.value[node.id].sticky ? 'btn-primary active' : 'btn-secondary'),
        onClick: function onClick(e) {
          e && e.preventDefault();
          var nodeValue = field.value[node.id];
          form.setFieldValue(field.name, _objectSpread(_objectSpread({}, field.value), {}, _defineProperty({}, node.id, _objectSpread(_objectSpread({}, nodeValue), {}, {
            sticky: !nodeValue.sticky
          }))));
        }
      }, /*#__PURE__*/_react["default"].createElement(_pushpin["default"], null)));
    };
    return [{
      name: 'assignment',
      title: 'Quest',
      content: /*#__PURE__*/_react["default"].createElement(_AssignmentForm["default"], {
        values: values,
        setFieldValue: setFieldValue
      })
    }, {
      name: 'columns',
      title: 'Columns',
      content: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Panel["default"], {
        header: "Respondent"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        name: "search",
        className: "form-control",
        placeholder: "search",
        style: {
          width: '10em'
        },
        autoFocus: true,
        autoComplete: "off",
        value: search,
        onChange: function onChange(e) {
          return setSearch(e.target.value);
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].content
      }, filteredTree.length === 0 ? 'No column found' : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "columns",
        render: function render(_ref) {
          var field = _ref.field,
            form = _ref.form;
          return filteredTree.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: item.id
            }, _traverse(item, field, form));
          });
        }
      })))), /*#__PURE__*/_react["default"].createElement(_Panel["default"], {
        header: "Deployment"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "waveName",
        label: "Data Collection Wave name",
        component: _CheckboxInput["default"]
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "waveTimepoint",
        label: "Data Collection Wave timepoint",
        component: _CheckboxInput["default"]
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "surveyLanguage",
        label: "Language",
        component: _CheckboxInput["default"]
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "surveyList",
        label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Form", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Form shows which form (a custom set of surveys) was selected or assigned to this set of responses. This is always \u2018default\u2019 unless your Quest is configured to use multiple forms. This is unusual."
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-primary"
        }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))),
        component: _CheckboxInput["default"]
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "assignmentStatus",
        label: "Completion Status",
        component: _CheckboxInput["default"]
      }))), /*#__PURE__*/_react["default"].createElement(_Panel["default"], {
        header: "Metrics"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "metrics",
        component: _MetricsPicker["default"],
        options: variablesOptions
      }))))
    }, {
      name: 'filter',
      title: 'Filter',
      content: /*#__PURE__*/_react["default"].createElement(ColumnTreeContext.Provider, {
        value: columnTree
      }, /*#__PURE__*/_react["default"].createElement(_FilterForm["default"], {
        values: values.filter,
        addFilter: function addFilter() {
          setFieldValue('filter', {
            aggregation: 'all',
            conditions: [{
              id: 1,
              column: null,
              operator: ''
            }]
          });
        },
        removeFilter: function removeFilter() {
          setFieldValue('filter', null);
        }
      })),
      hasError: submitCount > 0 && Object.keys(errors).some(function (key) {
        return /^filter\./.test(key);
      })
    }, {
      name: 'settings',
      title: 'Settings',
      content: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "codedValues",
        label: "Coded values",
        component: _CheckboxInput["default"],
        tooltip: "If unchecked, displays the raw value for the collected metrics. If checked, displays the coded value."
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "showQueryTo",
        label: "Show query to:",
        render: function render(_ref2) {
          var field = _ref2.field,
            form = _ref2.form;
          var value = field.value || 'all';
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "mb-3 mt-3"
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "form-label"
          }, "Show query to:"), showQueryToOptions.map(function (option) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: option.value,
              className: "form-check"
            }, /*#__PURE__*/_react["default"].createElement("label", {
              className: "form-check-label"
            }, /*#__PURE__*/_react["default"].createElement("input", {
              className: "form-check-input",
              type: "radio",
              name: field.name,
              value: option.value,
              checked: value === option.value,
              onChange: function onChange() {
                return form.setFieldValue(field.name, option.value);
              }
            }), ' ', option.label));
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: "alert alert-info",
            style: {
              marginTop: '0.8em',
              padding: '0.5em'
            }
          }, /*#__PURE__*/_react["default"].createElement("b", null, "Note:"), " any fields that are identifiable will be hidden from users that have access to this query but not identifiable permission."));
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
        title: "Download CSV - header options"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "csvHeaders",
        label: "CSV headers",
        render: function render(_ref3) {
          var field = _ref3.field,
            form = _ref3.form;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "mb-3"
          }, csvHeaderOptions.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: item.value,
              className: "form-check"
            }, /*#__PURE__*/_react["default"].createElement("label", {
              className: "form-check-label"
            }, /*#__PURE__*/_react["default"].createElement("input", {
              className: "form-check-input",
              type: "checkbox",
              value: item.value,
              checked: (field.value || ['label']).includes(item.value),
              onChange: function onChange() {
                var list = (0, _xor2["default"])(field.value || ['label'], [item.value]);
                // use order of the original list
                var newValue = csvHeaderOptions.filter(function (option) {
                  return list.includes(option.value);
                }).map(function (option) {
                  return option.value;
                });
                form.setFieldValue(field.name, newValue);
              }
            }), ' ', item.label));
          }));
        }
      })), restrictionsLevel === 'unlimited' && /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
        title: "Advanced settings"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "tags",
        label: "Tags",
        component: _TagInput["default"],
        availableTags: availableTags
      })))
    }];
  };
  return /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    tabList: getTabs()
  });
};
FormItself.propTypes = {
  values: _propTypes["default"].object,
  setFieldValue: _propTypes["default"].func,
  submitCount: _propTypes["default"].number,
  errors: _propTypes["default"].object,
  assignmentMetrics: _propTypes["default"].object,
  loadAssignmentMetrics: _propTypes["default"].func
};
var CustomQueryForm = function CustomQueryForm(props) {
  var project = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProject)(state.assignment.admin);
  });
  var currentQueryName = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentQueryName)(state.assignment.admin);
  });
  var deleteQuery = function deleteQuery() {
    (0, _cccisdConfirm["default"])({
      message: 'Are you sure?',
      description: "You are about to delete a query \"".concat(currentQueryName, "\"")
    }).then(function () {
      props.onDelete();
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: props.initialValues,
    onSubmit: function onSubmit(values) {
      // TODO: include metrics only for selected surveys
      var includingList = (0, _flatten2["default"])(values.variablesOptions.filter(function (option) {
        return !values.metrics.types.includes(option.value);
      }).map(function (option) {
        return option.list.map(function (item) {
          return item.id;
        });
      }));
      var result = _objectSpread(_objectSpread({}, (0, _omit2["default"])(values, 'variablesOptions')), {}, {
        assignmentId: Number(values.assignmentId),
        metrics: _objectSpread(_objectSpread({}, values.metrics), {}, {
          list: (0, _intersection2["default"])(values.metrics.list, includingList)
        })
      });
      props.onSubmit(result);
      props.closeModal();
    },
    validate: validate,
    render: function render(_ref4) {
      var handleSubmit = _ref4.handleSubmit,
        values = _ref4.values,
        errors = _ref4.errors,
        submitCount = _ref4.submitCount,
        setFieldValue = _ref4.setFieldValue,
        rest = _objectWithoutProperties(_ref4, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(FormItself, {
        values: values,
        setFieldValue: setFieldValue,
        errors: errors,
        submitCount: submitCount,
        assignmentMetrics: props.assignmentMetrics,
        loadAssignmentMetrics: props.loadAssignmentMetrics
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttonArea
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit",
        onClick: handleSubmit
      }, "Submit"), props.onDelete && Fortress.hasAccess('quest.tables_edit', project.groupId) && /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-danger",
        type: "button",
        onClick: deleteQuery
      }, "Delete query")));
    }
  });
};
CustomQueryForm.propTypes = {
  initialValues: _propTypes["default"].object,
  closeModal: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  onDelete: _propTypes["default"].func,
  assignmentMetrics: _propTypes["default"].object,
  loadAssignmentMetrics: _propTypes["default"].func
};
CustomQueryForm.defaultProps = {};
var _default = exports["default"] = CustomQueryForm;